import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../../../core/layout/Dialog';
import AudioPreview from '../../../../core/layout/AudioPreview';
import Table from '../../../../core/form/Table';
import Button from '../../../../core/form/Button';
import Tag from '../../../../core/layout/Tag';

const StudentDetailExecutionResultDialog = (props) => (
  <Dialog
    width="90%"
    isOpen={props.isOpen}
    title="Execution Details"
    onCancel={props.onClose}
    actions={[<Button key="close" icon="close-circle" label="Close" onClick={props.onClose} />]}
  >
    <Table
      rows={props.items}
      columns={[
        {
          label: 'Correct',
          path: 'correct',
          width: '70px',
          align: 'center',
          render: (value) => <Tag color={value ? 'green' : 'red'}>{value ? 'Yes' : 'No'}</Tag>,
        },
        {
          label: 'Question/Subject',
          path: 'item.text',
        },
        {
          label: 'Attempts',
          path: 'attempts.length',
        },
        {
          label: 'Last Answer/Score',
          path: 'attempts',
          render: (attempts, row) => {
            const lastAttempt = attempts ? attempts.length && attempts[attempts.length - 1] : '';
            if (row.item.type.key === 'MULTIPLE_CHOICE_TEXT') {
              return <div style={{ whiteSpace: 'pre-line' }}>{lastAttempt.answer.replace('/\n/g', '<br/>')}</div>;
            }
            if (['CONNECTING_DOTS', 'MEMORY_GAME', 'VOCABULARY_GAME'].some((type) => type === row.item.type.key)) {
              return props.items.find((ei) => ei.item?.id === lastAttempt.answer)?.item?.text;
            }
            return lastAttempt.answer;
          },
        },
        {
          label: 'Last Record',
          path: 'lastRecord',
          width: '130px',
          align: 'center',
          render: (value) => value && <AudioPreview src={value} />,
        },
      ]}
    />
  </Dialog>
);

StudentDetailExecutionResultDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default StudentDetailExecutionResultDialog;
